enum OperationPlanState {
  PLAN_ON = "planOn",
  PLAN_OFF = "planOff",
}

export default OperationPlanState
